/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Icon } from '@mayoral/ui';
import { Stack, styled, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import { FC } from 'react';

import theme from '@/theme';

type HelperTextProps = {
  error: string;
  size?: number;
  sx?: object;
};

const HelperTextIcon = styled(Box, {
  name: 'HelperText',
  slot: 'Icon',
})(({ theme }) => ({
  flexShrink: 0,
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 12,
  height: 12,
  marginRight: theme.spacing(0.5),
  backgroundColor: theme.palette.error.main,
  borderRadius: 50,
}));

const HelperText: FC<HelperTextProps> = ({ error, size = 15, sx }) => {
  return (
    <Stack
      component="span"
      direction="row"
      alignItems="center"
      sx={{ color: theme.palette.error.main, ...sx }}
    >
      <HelperTextIcon component="span">
        <Icon
          name="CloseS"
          sx={{
            fontSize: 12,
            path: { fill: (theme) => theme.palette.common.white },
          }}
        />
      </HelperTextIcon>
      <Typography sx={{ fontSize: size }}>{error}</Typography>
    </Stack>
  );
};

export default HelperText;
